import { Authentication } from '../models';
import ApiResource from './ApiResource';

class RouterResource extends ApiResource<Authentication> {
  static isRouterResource = true;
  public endpoint = '/connect/router';
}

export const routerResource = new RouterResource();
